import { get } from 'lodash';
import { useSelector } from 'react-redux';

import { getCurrentDutyInfo } from '../../../selectors/sended-data';

export const useDutyTimePanel = () => {
    const currentLeg = useSelector((state) => get(state, 'screen.currentLeg'));
    const { dutyTime, startWorkTime } = useSelector(getCurrentDutyInfo);

    return {
        isDutyTime: !!(dutyTime || startWorkTime),
        currentLeg,
    };
};
